import { useEffect } from "react";
import { prefersReducedMotion } from "./reducedMotion";

const ITEM_SEL = "article, li, [data-reveal-item]";
const CLEANUP_MS = 1800;

// Sections fade up once when scrolled into view; cards/list items stagger 60 ms.
// Start state is set here (JS), so prerendered HTML stays fully visible.
export function useReveal(deps = []) {
  useEffect(() => {
    if (prefersReducedMotion() || !("IntersectionObserver" in window)) return undefined;
    const vh = window.innerHeight;
    const groups = new Map();
    document.querySelectorAll("main section").forEach((sec) => {
      if (sec.parentElement.closest("main section") || sec.getBoundingClientRect().top < vh * 0.9) return;
      const items = [...sec.querySelectorAll(ITEM_SEL)].slice(0, 24);
      const nodes = [...sec.children, ...items];
      items.forEach((it, k) => it.style.setProperty("--rd", `${120 + k * 60}ms`));
      nodes.forEach((n) => n.classList.add("reveal-pending"));
      groups.set(sec, nodes);
    });
    const lines = [...document.querySelectorAll(".draw-line")];
    lines.forEach((l) => l.classList.add("line-pending"));

    const timers = [];
    const io = new IntersectionObserver((entries) => {
      entries.forEach(({ isIntersecting, target }) => {
        if (!isIntersecting) return;
        io.unobserve(target);
        if (target.classList.contains("draw-line")) {
          target.classList.replace("line-pending", "line-in");
          return;
        }
        const nodes = groups.get(target) || [];
        nodes.forEach((n) => n.classList.replace("reveal-pending", "reveal-in"));
        timers.push(setTimeout(() => nodes.forEach((n) => { n.classList.remove("reveal-in"); n.style.removeProperty("--rd"); }), CLEANUP_MS));
      });
    }, { threshold: 0.1, rootMargin: "0px 0px -8% 0px" });
    groups.forEach((_, sec) => io.observe(sec));
    lines.forEach((l) => io.observe(l));
    return () => {
      io.disconnect();
      timers.forEach(clearTimeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
